import { Paper, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { IFilteringViewModel } from "../../_common/interface/table";
import { CommonTable } from "../../_components/table/common.table";
import { SECONDARY_COLOR_DARKER } from "../../_const/color.const";
import { getDateStringNormalized } from "../../_helpers/dateTime.helper";
import { getMoneyFormat } from "../../_helpers/format.helper";
import { userFineService } from "../../_services/userFineService.service";


export function UserProfileFinesList(params: {}) {

    const { userId } = useParams<{ userId: string }>();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 100, page: 0, order: 'desc', orderBy: '' });

    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {
        if (!userId) return;
        setLoading(true);
        return userFineService
            .getAllByUserId(userId)
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function viewDetails(id: number) {
        navigate("" + id)
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [

            {
                accessorKey: 'name',
                header: 'Name'
            },
            {
                accessorKey: 'description',
                header: 'Description',
            },
            {
                accessorKey: 'price',
                header: 'Price',
                accessorFn: (rowData: any) => <>{!rowData.isChargeable ? "N/A" : getMoneyFormat(rowData.price)}</>,
            },
            {
                accessorKey: 'durationBan',
                header: 'Duration Ban',
                accessorFn: (rowData: any) => <>{!rowData.isBannedIndefinitely ? rowData.durationBan > 1 ? rowData.durationBan + " days" : rowData.durationBan + " day" : "N/A"}</>,
            },
            {
                accessorKey: 'isPaid',
                header: 'Is Paid',
                accessorFn: (rowData: any) => <>{!rowData.isChargeable ? "N/A" : rowData.isPaid ? "Paid" : "Not Paid"}</>,
            },
            {
                accessorKey: 'isActive',
                header: 'Is Active',
                accessorFn: (rowData: any) => <>{rowData.isActive ? "Active" : "InActive"}</>,
            },
            {
                accessorKey: 'isBannedIndefinitely',
                header: 'Is Banned Indefinitely',
                accessorFn: (rowData: any) => <>{rowData.isBannedIndefinitely ? "Yes" : "No"}</>,
            },
            {
                accessorKey: 'createdDate',
                header: 'Created Date',
                accessorFn: (rowData: any) => <>{getDateStringNormalized(rowData.createdDate)}</>,
            }
        ],
        [],
    );
    return (
        <>
            <Paper>
                <Typography variant="h5" color={SECONDARY_COLOR_DARKER} textAlign="center">My Fines</Typography>
                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                    onView={(d) => { viewDetails(Number(d)) }}
                />
                <Outlet></Outlet>
            </Paper>
        </>
    );
}